const PUBLIC_API_URL = "https://d29a52ery9.execute-api.us-east-1.amazonaws.com/prod";
const SUBSCRIBE_URL = `${PUBLIC_API_URL}/newsletter/subscribe`;
const CONFIRM_URL = `${PUBLIC_API_URL}/newsletter/confirm`;
const UNSUBSCRIBE_URL = `${PUBLIC_API_URL}/newsletter/unsubscribe`;

export type SubscribeStatus = "pending";
export type ConfirmStatus = "subscribed" | "already_subscribed";
export type UnsubscribeStatus = "unsubscribed" | "already_unsubscribed";

export interface NewsletterResponse<TStatus extends string> {
    status?: TStatus;
    error?: string;
}

function postJson<TStatus extends string>(
    url: string,
    payload: Record<string, string>
): Promise<NewsletterResponse<TStatus>> {
    return fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    }).then((res) => res.json() as Promise<NewsletterResponse<TStatus>>);
}

export function subscribeToNewsletter(email: string) {
    return postJson<SubscribeStatus>(SUBSCRIBE_URL, { email });
}

export function confirmNewsletterSubscription(email: string, token: string, issuedAt: string) {
    return postJson<ConfirmStatus>(CONFIRM_URL, { email, token, t: issuedAt });
}

export function unsubscribeFromNewsletter(email: string, token: string) {
    return postJson<UnsubscribeStatus>(UNSUBSCRIBE_URL, { email, token });
}
